import { dataMember, required, typedArray } from 'santee-dcts';
import { UserInfo } from './user-info';

export class UserEmulationsReadModel {
    @dataMember()
    @required({ nullable: true })
    @typedArray(UserInfo)
    public users: UserInfo[];

    @dataMember()
    @required()
    public currentPage: number;

    @dataMember()
    @required()
    public totalPages: number;
}

export interface SearchParams {
    firstName: string;
    lastName: string;
    userName: string;
    protocol: string;
    covanceProjectNumber: string;
    siteNumber: string;
    sponsorFilter: string;
    clientProtocolFilter: string;
    covanceProjectNumberFilter: string;
    regionFilter: string;
    siteNumFilter: string;
    investigatorFilter: string;
    applicationRoleFilter: string;
    blindingRoleFilter: string;
}

export interface LoadUserParams {
    searchParams: SearchParams;
    page: number;
}